import React, { Component } from 'react';
import { Button, Col, Container, Row, InputGroup, Card, CardBody } from 'reactstrap';
import queryString from 'query-string';
import Language from '../../../../components/Language/Language';
import { Link } from 'react-router-dom';
import Logout from '../../../../components/Logout/Logout';

var CryptoJS = require("crypto-js");

class CustErrorPage extends Component {

  constructor(props) {
    super(props);
    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
    let url = this.props.location.search;
    var encryptquerystring = props.location.search.split('error=')[1];

    if (encryptquerystring == null || encryptquerystring == "" || encryptquerystring == undefined) {
      this.state = {
        errorcode: "400",
        errormessage: "Error Occur",
        referenceID: "",
      };
    }
    else {
      var bytes = CryptoJS.AES.decrypt(encryptquerystring.toString(), SECRET_KEY);
      let params = queryString.parse(bytes.toString(CryptoJS.enc.Utf8));

      var errorcode = "";
      var errormessage = "";
      var referenceID = "";

      if (params.errorcode == null || params.errorcode == "" || params.errorcode == undefined) {
        errorcode = "400";
      }
      else {
        errorcode = params.errorcode;
      }

      if (params.errormessage == null || params.errormessage == "" || params.errormessage == undefined) {
        errormessage = "Error Occur";
      }
      else {
        errormessage = params.errormessage;
      }

      if (params.referenceID == null || params.referenceID == "" || params.referenceID == undefined) {
        referenceID = "";
      }
      else {
        referenceID = params.referenceID;
      }

      this.state = {
        errorcode: errorcode,
        errormessage: errormessage,
        referenceID: referenceID != "" ? 'Please refer Reference ID ' + params.referenceID : '',
      };
    }

    this.RedirectLogin = this.RedirectLogin.bind(this);
  }

  componentDidMount() {
    Language.BindLanguageControl()
  }

  RedirectLogin() {
    if (sessionStorage.getItem("accessToken") == null || sessionStorage.getItem("refreshToken") == null) {
      Logout.logoutHelper();
    } else {
      Logout.helper();
    }
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <Card>
                <CardBody>
                  <div className="clearfix">
                    <Col>
                      <h1 className="float-left display-3 mr-4">{this.state.errorcode}</h1>
                    </Col>
                    <Col md="12">
                      <h4 className="pt-3">{this.state.errormessage}</h4>
                    </Col>
                    <p className="text-muted float-left" data-langid="3635.01">The page you are looking for was not found.</p>
                    <p className="text-muted float-left">{this.state.referenceID}</p>
                  </div>
                  <InputGroup className="input-prepend">
                    <Button type="submit" className="btn btn-danger" id="btnBackLogin" onClick={this.RedirectLogin}>Back to Login</Button>
                  </InputGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container >
      </div >
    );
  }
}

export default CustErrorPage;
